import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@styles/main.scss';
import '@bn-apps/dim-ui-tokens/tokens.css';
import '@bn-apps/dim-ui-react/styles.css';
import '@bn-apps/dim-ui-entity/react.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <App />
);
